module.exports = __webpack_public_path__ + "public/images/calendar-recurring.3ee835ca8cbf29a997b76e28626e9027.png";